"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _FeedbackInstance_instances, _FeedbackInstance_sdk, _FeedbackInstance_userContext, _FeedbackInstance_poll, _FeedbackInstance_language, _FeedbackInstance_modules, _FeedbackInstance_response, _FeedbackInstance_blocked, _FeedbackInstance_stepIndex, _FeedbackInstance_trigger, _FeedbackInstance_settings, _FeedbackInstance_defaultSettings, _FeedbackInstance_settingsOverride, _FeedbackInstance_triggerParams, _FeedbackInstance_nav, _FeedbackInstance_dataToSend, _FeedbackInstance_parseTriggerData, _FeedbackInstance_parseDataFromTrigger, _FeedbackInstance_buildSettings, _FeedbackInstance_buildModules, _FeedbackInstance_isRowValid, _FeedbackInstance_getRowErrors, _FeedbackInstance_isPageValid, _FeedbackInstance_getStepErrors, _FeedbackInstance_buildNav;
Object.defineProperty(exports, "__esModule", { value: true });
const { merge } = require('lodash');
const EventEmitter_1 = __importDefault(require("./EventEmitter"));
const core_1 = require("./utils/core");
const Module_1 = __importDefault(require("./models/Module"));
const ThanksModule_1 = require("./models/ThanksModule");
const { get, set } = require("lodash");
const constants_1 = require("./constants");
const ModuleAnswer_1 = __importDefault(require("./ModuleAnswer"));
const QuestionsMatrix_1 = __importDefault(require("./models/QuestionsMatrix"));
class FeedbackInstance extends EventEmitter_1.default {
    constructor(sdk, { triggerParams, defaultSettings, settingsOverride, poll }) {
        var _a, _b;
        super();
        _FeedbackInstance_instances.add(this);
        this.id = Math.random();
        _FeedbackInstance_sdk.set(this, undefined);
        _FeedbackInstance_userContext.set(this, {});
        _FeedbackInstance_poll.set(this, undefined);
        _FeedbackInstance_language.set(this, undefined);
        _FeedbackInstance_modules.set(this, []);
        _FeedbackInstance_response.set(this, {
            modules: [],
        });
        _FeedbackInstance_blocked.set(this, false);
        _FeedbackInstance_stepIndex.set(this, -1);
        _FeedbackInstance_trigger.set(this, undefined);
        _FeedbackInstance_settings.set(this, constants_1.defaultInstanceSettings);
        _FeedbackInstance_defaultSettings.set(this, {});
        _FeedbackInstance_settingsOverride.set(this, {});
        _FeedbackInstance_triggerParams.set(this, {});
        _FeedbackInstance_nav.set(this, {
            progress: {
                total: 0,
                valid: 0,
                percentage: 0,
            },
            pages: [],
            isLast: false,
            valid: false,
            canGoNext: false,
            blocked: false,
            stepIndex: 0,
            answers: [],
            pageStarts: [],
        });
        _FeedbackInstance_dataToSend.set(this, void 0);
        __classPrivateFieldSet(this, _FeedbackInstance_sdk, sdk, "f");
        this.setSettingsOverride(settingsOverride);
        if (defaultSettings) {
            __classPrivateFieldSet(this, _FeedbackInstance_defaultSettings, defaultSettings, "f");
        }
        if (triggerParams) {
            this.triggerParams = triggerParams;
        }
        if (poll) {
            this.setPoll(poll);
        }
        this.changeLanguage((poll === null || poll === void 0 ? void 0 : poll.language) || 'es');
        this.on([
            'modules:change',
            'stepIndex',
        ], () => __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_buildNav).call(this));
        (_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.on(['form-data'], () => __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_buildSettings).call(this));
        (_b = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _b === void 0 ? void 0 : _b.on(['form-data', 'answered-polls', 'external-id'], () => __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_parseTriggerData).call(this));
        this.on(['trigger-params'], () => __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_parseTriggerData).call(this));
        this.log(['created', this]);
    }
    get language() {
        return __classPrivateFieldGet(this, _FeedbackInstance_language, "f");
    }
    set dataToSend(data) {
        __classPrivateFieldSet(this, _FeedbackInstance_dataToSend, data, "f");
        this.emit('dataToSend', __classPrivateFieldGet(this, _FeedbackInstance_dataToSend, "f"));
    }
    get dataToSend() {
        return __classPrivateFieldGet(this, _FeedbackInstance_dataToSend, "f");
    }
    log(payload) {
        var _a;
        (_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.log([
            `instance:${this.id}`,
            ...payload,
        ]);
    }
    get sdk() {
        return __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f");
    }
    setPollById(pollId) {
        var _a, _b;
        const poll = (_b = (_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.formData) === null || _b === void 0 ? void 0 : _b.polls.find(find => find.id === pollId);
        this.setPoll(poll);
    }
    setSettingsOverride(settingsOverride) {
        if (settingsOverride) {
            __classPrivateFieldSet(this, _FeedbackInstance_settingsOverride, settingsOverride, "f");
        }
    }
    setPoll(poll) {
        var _a;
        if (poll === __classPrivateFieldGet(this, _FeedbackInstance_poll, "f"))
            return;
        __classPrivateFieldSet(this, _FeedbackInstance_poll, poll, "f");
        __classPrivateFieldSet(this, _FeedbackInstance_settings, (0, core_1.buildInstanceSettings)({
            formData: (_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.formData,
            poll,
            defaultSettings: __classPrivateFieldGet(this, _FeedbackInstance_defaultSettings, "f"),
            settingsOverride: __classPrivateFieldGet(this, _FeedbackInstance_settingsOverride, "f"),
        }), "f");
        this.log(['setPoll', poll, {
                settings: __classPrivateFieldGet(this, _FeedbackInstance_settings, "f"),
            }]);
        this.emit('settings', __classPrivateFieldGet(this, _FeedbackInstance_settings, "f"));
        this.log(['settings', __classPrivateFieldGet(this, _FeedbackInstance_settings, "f")]);
        __classPrivateFieldGet(this, _FeedbackInstance_response, "f").modules = ((poll === null || poll === void 0 ? void 0 : poll.modules) || []).map((module) => {
            const moduleAnswer = new ModuleAnswer_1.default(module);
            moduleAnswer.on('change', () => {
                __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_buildModules).call(this);
                this.emit('moduleAnswer:change', moduleAnswer);
            });
            return moduleAnswer;
        });
        this.stepIndex = 0;
        __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_buildModules).call(this);
        this.emit('poll', __classPrivateFieldGet(this, _FeedbackInstance_poll, "f"));
    }
    changeLanguage(language) {
        var _a, _b, _c, _d;
        if (!get(__classPrivateFieldGet(this, _FeedbackInstance_poll, "f"), 'metadata.translations.enabled'))
            return;
        __classPrivateFieldSet(this, _FeedbackInstance_language, language, "f");
        if (this.modules && this.modules.length > 0) {
            __classPrivateFieldSet(this, _FeedbackInstance_modules, (_a = __classPrivateFieldGet(this, _FeedbackInstance_modules, "f")) === null || _a === void 0 ? void 0 : _a.map((module) => {
                if (module instanceof Module_1.default) {
                    return this.translateModule(module, language);
                }
                else if (module instanceof QuestionsMatrix_1.default) {
                    module.modules = module.modules.map((question) => {
                        return this.translateModule(question, language);
                    });
                    return module;
                }
                return this.translateModule(module, language);
            }), "f");
        }
        // poll change
        // this.modules does not have the TY page question
        if (((_b = __classPrivateFieldGet(this, _FeedbackInstance_poll, "f")) === null || _b === void 0 ? void 0 : _b.modules) && ((_c = __classPrivateFieldGet(this, _FeedbackInstance_poll, "f")) === null || _c === void 0 ? void 0 : _c.modules.length) > 0) {
            __classPrivateFieldGet(this, _FeedbackInstance_poll, "f").modules = (_d = __classPrivateFieldGet(this, _FeedbackInstance_poll, "f").modules) === null || _d === void 0 ? void 0 : _d.map((module) => {
                if (module instanceof ThanksModule_1.ThanksModule)
                    return this.translateModule(module, language);
                return module;
            });
        }
        const translations = get(this.poll, `metadata.translations.${language}`, {});
        Object.keys(translations).forEach((path) => {
            let value = get(translations, path, get(__classPrivateFieldGet(this, _FeedbackInstance_poll, "f"), path));
            set(__classPrivateFieldGet(this, _FeedbackInstance_poll, "f"), path, value);
        });
        this.setPoll(__classPrivateFieldGet(this, _FeedbackInstance_poll, "f"));
        this.emit('modules:change', __classPrivateFieldGet(this, _FeedbackInstance_modules, "f"));
    }
    translateModule(module, language) {
        const translations = get(module, `metadata.translations.${language}`, {});
        module.language = language;
        Object.keys(translations).forEach((path) => {
            let value = get(translations, path, get(module, path));
            set(module, path, value);
        });
        // motives translations
        module.motives = get(module, 'motives', []).map((motive) => {
            const newMotive = Object.assign({}, motive);
            const translations = get(newMotive, `metadata.translations.${language}`, {});
            Object.keys(translations).forEach((path) => {
                let value = get(translations, path, get(newMotive, path));
                set(newMotive, path, value);
            });
            return newMotive;
        });
        if (module instanceof ThanksModule_1.ThanksModule)
            return new ThanksModule_1.ThanksModule(Object.assign({}, module));
        return new Module_1.default(Object.assign({}, module));
    }
    get poll() {
        return __classPrivateFieldGet(this, _FeedbackInstance_poll, "f");
    }
    get settings() {
        return __classPrivateFieldGet(this, _FeedbackInstance_settings, "f");
    }
    appendUserContext(data) {
        Object.assign(__classPrivateFieldGet(this, _FeedbackInstance_userContext, "f"), data);
    }
    set triggerParams(triggerParams) {
        __classPrivateFieldSet(this, _FeedbackInstance_triggerParams, triggerParams, "f");
        this.emit('trigger-params', triggerParams);
    }
    set stepIndex(index) {
        if (index === __classPrivateFieldGet(this, _FeedbackInstance_stepIndex, "f"))
            return;
        __classPrivateFieldSet(this, _FeedbackInstance_stepIndex, index, "f");
        this.emit('stepIndex', __classPrivateFieldGet(this, _FeedbackInstance_stepIndex, "f"));
    }
    goNext() {
        if (!__classPrivateFieldGet(this, _FeedbackInstance_nav, "f").currentPage)
            return;
        const errors = __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_getStepErrors).call(this, __classPrivateFieldGet(this, _FeedbackInstance_nav, "f").currentPage);
        if (errors.length > 0) {
            throw errors[0];
        }
        this.stepIndex = __classPrivateFieldGet(this, _FeedbackInstance_stepIndex, "f") + 1;
    }
    get nav() {
        return __classPrivateFieldGet(this, _FeedbackInstance_nav, "f");
    }
    getModuleAnswerByIndex(index) {
        return __classPrivateFieldGet(this, _FeedbackInstance_response, "f").modules[index];
    }
    get mergedUserContext() {
        var _a;
        return merge({}, (_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.userContext, __classPrivateFieldGet(this, _FeedbackInstance_userContext, "f"));
    }
    postFormData({ data, raw } = {}) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const hash = ((_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.auth.hash) || 'iframe';
            const body = (() => {
                var _a, _b;
                if (raw)
                    return raw;
                const answers = __classPrivateFieldGet(this, _FeedbackInstance_response, "f").modules.map((moduleInstance) => moduleInstance.toPayload());
                const externalId = (_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.externalId;
                const payload = {
                    data: Object.assign(Object.assign({}, data), { poll_id: (_b = __classPrivateFieldGet(this, _FeedbackInstance_poll, "f")) === null || _b === void 0 ? void 0 : _b.id, answers, userContext: this.mergedUserContext }),
                };
                if (externalId)
                    merge(payload, {
                        data: {
                            form: {
                                contact: {
                                    externalId,
                                },
                            },
                        },
                    });
                return payload;
            })();
            ((_b = __classPrivateFieldGet(this, _FeedbackInstance_poll, "f")) === null || _b === void 0 ? void 0 : _b.id) && ((_c = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _c === void 0 ? void 0 : _c.pushToAnsweredPolls((_d = __classPrivateFieldGet(this, _FeedbackInstance_poll, "f")) === null || _d === void 0 ? void 0 : _d.id));
            if ((_e = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _e === void 0 ? void 0 : _e.debug) {
                return this.log([`POST /api/v1/form-data/${hash || ''}`, JSON.stringify(body.data, null, 2)]);
            }
            const response = yield ((_f = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _f === void 0 ? void 0 : _f.request({
                path: `v1/form-data/${hash || ''}`,
                method: 'POST',
                body: JSON.stringify(body),
            }));
            this.setPoll(undefined);
            return response;
        });
    }
    get modules() {
        return __classPrivateFieldGet(this, _FeedbackInstance_modules, "f");
    }
    get response() {
        return __classPrivateFieldGet(this, _FeedbackInstance_response, "f");
    }
    buildPageStarts() {
        var _a;
        const questionsValid = (_a = __classPrivateFieldGet(this, _FeedbackInstance_modules, "f")) !== null && _a !== void 0 ? _a : [];
        const { pageSize } = __classPrivateFieldGet(this, _FeedbackInstance_settings, "f").nav;
        const starts = [];
        let questionsInPage = 1;
        questionsValid.forEach((question, index) => {
            if (questionsInPage === 1)
                starts.push(index);
            if (question.isBreaker) {
                questionsInPage = 1;
            }
            else {
                if (questionsInPage === pageSize) {
                    questionsInPage = 1;
                }
                else {
                    questionsInPage++;
                }
            }
        });
        // const pageStarts = [
        //   0,
        //   ...questionsValid
        //     .map((question: any, index: any) => {
        //       return question.isBreaker ? index + 1 : undefined
        //     }
        //     )
        //     .filter((index: any) => index !== undefined),
        // ];
        // [...pageStarts].forEach((pageStartIndex, index) => {
        //   const nextPageStart =
        //     pageStarts[index + 1] !== undefined
        //       ? pageStarts[index + 1]
        //       : questionsValid.length - 1;
        //   const pageSizeBreaks = Math.trunc(
        //     (nextPageStart - pageStartIndex) / pageSize,
        //   );
        //   Array.from({ length: pageSizeBreaks }).forEach((value, index) => {
        //     const pageSizeBreak = pageStartIndex + (index + 1) * pageSize;
        //     if (!pageStarts.includes(pageSizeBreak)) pageStarts.push(pageSizeBreak);
        //   });
        // });
        // pageStarts.sort((a, b) => a - b);
        return starts;
    }
}
exports.default = FeedbackInstance;
_FeedbackInstance_sdk = new WeakMap(), _FeedbackInstance_userContext = new WeakMap(), _FeedbackInstance_poll = new WeakMap(), _FeedbackInstance_language = new WeakMap(), _FeedbackInstance_modules = new WeakMap(), _FeedbackInstance_response = new WeakMap(), _FeedbackInstance_blocked = new WeakMap(), _FeedbackInstance_stepIndex = new WeakMap(), _FeedbackInstance_trigger = new WeakMap(), _FeedbackInstance_settings = new WeakMap(), _FeedbackInstance_defaultSettings = new WeakMap(), _FeedbackInstance_settingsOverride = new WeakMap(), _FeedbackInstance_triggerParams = new WeakMap(), _FeedbackInstance_nav = new WeakMap(), _FeedbackInstance_dataToSend = new WeakMap(), _FeedbackInstance_instances = new WeakSet(), _FeedbackInstance_parseTriggerData = function _FeedbackInstance_parseTriggerData() {
    var _a, _b, _c, _d, _e;
    const triggerData = {
        answeredPolls: (_b = (_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.answeredPolls) !== null && _b !== void 0 ? _b : [],
        formData: (_c = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _c === void 0 ? void 0 : _c.formData,
        triggerData: Object.assign(Object.assign({}, __classPrivateFieldGet(this, _FeedbackInstance_triggerParams, "f")), { externalId: (_d = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _d === void 0 ? void 0 : _d.externalId, userContext: this.mergedUserContext, contact: (_e = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _e === void 0 ? void 0 : _e.contactData }),
    };
    const trigger = (0, core_1.triggerFromFormData)(triggerData);
    __classPrivateFieldSet(this, _FeedbackInstance_trigger, trigger, "f");
    __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_parseDataFromTrigger).call(this, { trigger });
    this.emit('trigger', __classPrivateFieldGet(this, _FeedbackInstance_trigger, "f"));
}, _FeedbackInstance_parseDataFromTrigger = function _FeedbackInstance_parseDataFromTrigger({ trigger }) {
    var _a, _b;
    if (!trigger)
        return;
    const { poll } = (0, core_1.matchTrigger)({ polls: (_b = (_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.formData) === null || _b === void 0 ? void 0 : _b.polls, trigger });
    if (poll) {
        this.log(['trigger:match', poll, trigger]);
    }
    this.setPoll(poll);
}, _FeedbackInstance_buildSettings = function _FeedbackInstance_buildSettings() {
    var _a;
    __classPrivateFieldSet(this, _FeedbackInstance_settings, (0, core_1.buildInstanceSettings)({
        formData: (_a = __classPrivateFieldGet(this, _FeedbackInstance_sdk, "f")) === null || _a === void 0 ? void 0 : _a.formData,
        defaultSettings: __classPrivateFieldGet(this, _FeedbackInstance_defaultSettings, "f"),
        settingsOverride: __classPrivateFieldGet(this, _FeedbackInstance_settingsOverride, "f"),
    }), "f");
    this.emit('settings', __classPrivateFieldGet(this, _FeedbackInstance_settings, "f"));
}, _FeedbackInstance_buildModules = function _FeedbackInstance_buildModules() {
    var _a, _b;
    const { modules: dynamicModules, blocked } = (0, core_1.getDynamicFlow)({
        modules: (_b = (_a = __classPrivateFieldGet(this, _FeedbackInstance_poll, "f")) === null || _a === void 0 ? void 0 : _a.sortedQuestions) !== null && _b !== void 0 ? _b : [],
        answers: __classPrivateFieldGet(this, _FeedbackInstance_response, "f").modules,
    });
    __classPrivateFieldSet(this, _FeedbackInstance_blocked, blocked || false, "f");
    // if (isEquivalent(dynamicModules, this.#modules ?? [])) return;
    __classPrivateFieldSet(this, _FeedbackInstance_modules, dynamicModules, "f");
    this.log(['modules:change', __classPrivateFieldGet(this, _FeedbackInstance_modules, "f")]);
    this.emit('modules:change', __classPrivateFieldGet(this, _FeedbackInstance_modules, "f"));
    this.changeLanguage(__classPrivateFieldGet(this, _FeedbackInstance_language, "f"));
}, _FeedbackInstance_isRowValid = function _FeedbackInstance_isRowValid(row) {
    var _a;
    const answers = __classPrivateFieldGet(this, _FeedbackInstance_response, "f").modules;
    if (row.type === 'module') {
        //@ts-ignore
        return (_a = row.module) === null || _a === void 0 ? void 0 : _a.isValid({ answers, components: row.components });
    }
    return true;
}, _FeedbackInstance_getRowErrors = function _FeedbackInstance_getRowErrors(row) {
    var _a;
    const answers = __classPrivateFieldGet(this, _FeedbackInstance_response, "f").modules;
    if (row.type === 'module') {
        //@ts-ignore
        return (_a = row.module) === null || _a === void 0 ? void 0 : _a.getErrors({ answers, components: row.components });
    }
    return [];
}, _FeedbackInstance_isPageValid = function _FeedbackInstance_isPageValid(step) {
    return step === null || step === void 0 ? void 0 : step.rows.reduce((ret, row) => {
        return __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_isRowValid).call(this, row);
    }, true);
}, _FeedbackInstance_getStepErrors = function _FeedbackInstance_getStepErrors(step) {
    return step === null || step === void 0 ? void 0 : step.rows.reduce((ret, row) => {
        return [
            ...ret,
            ...__classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_getRowErrors).call(this, row),
        ];
    }, []);
}, _FeedbackInstance_buildNav = function _FeedbackInstance_buildNav() {
    var _a, _b, _c, _d, _e;
    const answers = __classPrivateFieldGet(this, _FeedbackInstance_response, "f").modules;
    const pages = (0, core_1.buildInstanceSteps)({ instance: this });
    const currentPage = pages[__classPrivateFieldGet(this, _FeedbackInstance_stepIndex, "f")];
    const canGoNext = __classPrivateFieldGet(this, _FeedbackInstance_instances, "m", _FeedbackInstance_isPageValid).call(this, currentPage);
    const valid = (_c = (_b = (_a = __classPrivateFieldGet(this, _FeedbackInstance_poll, "f")) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.every((module) => module.isResponseValid(answers))) !== null && _c !== void 0 ? _c : true;
    const individualModules = ((_d = __classPrivateFieldGet(this, _FeedbackInstance_modules, "f")) !== null && _d !== void 0 ? _d : []).reduce((ret, module) => {
        return [...ret, ...module.getSubModules()];
    }, []);
    const validTotal = individualModules.length;
    const validCount = individualModules.reduce((count, module) => {
        return module.isResponseValid(answers) ? count + 1 : count;
    }, 0);
    __classPrivateFieldSet(this, _FeedbackInstance_nav, {
        progress: {
            total: validTotal,
            valid: validCount,
            percentage: validCount * 100 / validTotal,
        },
        answers,
        canGoNext,
        valid,
        blocked: __classPrivateFieldGet(this, _FeedbackInstance_blocked, "f"),
        isLast: __classPrivateFieldGet(this, _FeedbackInstance_stepIndex, "f") === ((_e = __classPrivateFieldGet(this, _FeedbackInstance_nav, "f")) === null || _e === void 0 ? void 0 : _e.pages.length) - 1 && !__classPrivateFieldGet(this, _FeedbackInstance_blocked, "f"),
        currentPage,
        stepIndex: __classPrivateFieldGet(this, _FeedbackInstance_stepIndex, "f"),
        pages,
        pageStarts: this.buildPageStarts()
    }, "f");
    this.log(['nav', __classPrivateFieldGet(this, _FeedbackInstance_nav, "f")]);
    this.emit('nav', __classPrivateFieldGet(this, _FeedbackInstance_nav, "f"));
};
